(function () {
    'use strict';

    var module = angular.module('uwAgenda.users');
    module.factory('UserBadgeCalculatorService', ['$filter', '$rootScope', 'UserFilterService', UserBadgeCalculatorServiceFn]);

    // service to handle overview specific things like precalculation for badges
    function UserBadgeCalculatorServiceFn($filter, $rootScope, UserFilterService) {

        // service class
        var service = {
            preCalculate: preCalculate
        };

        return service;

        // pre calculation for badges depending on calling directive
        function preCalculate(userList, rolesForUser, isRoleDirective, isGroupPracticeDirective) {
            if (userList === undefined) {
                return;
            }

            var arr = [];


            var selectedRoleTypes = UserFilterService.loadRoleFilter();

            // number of users with defined roletypes
            for (var x = 0; x < userList.length; x++) {
                var user = userList[x];
                var doPush = false;

                //only not deleted user
                if (user.deleted === true) {
                    continue;
                } // if

                if (isRoleDirective) {
                    doPush = UserFilterService.filterUser(user, null, rolesForUser);
                }
                else if (isGroupPracticeDirective) {
                    doPush = UserFilterService.filterUser(user, selectedRoleTypes, rolesForUser);
                }
                else {
                    //role & group practice
                    doPush = UserFilterService.filterUser(user, selectedRoleTypes, rolesForUser);
                }

                // add preselected users 
                if (doPush) {
                    arr.push(user);
                }

            } // for

            return arr;
        }
    }
})();